import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography,
  Zoom,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAppContext } from '../context/AppContext';
import { financialService } from '../utils/api';
import CONFIG from '../utils/config';

const initCalendly = () => {
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: CONFIG.calendly_link });
  }
};

const LastPage = () => {
  const { state, actions } = useAppContext();
  const [isLoading,          setIsLoading]          = useState(true);
  const [showDefaultThankYou,setShowDefaultThankYou] = useState(state.requestCallback);
  const [showFinalMinimal,   setShowFinalMinimal]    = useState(false);
  const [userChecked,        setUserChecked]         = useState(false);

  // Fire emailRecord on mount — this sets isQualified and unblocks the UI
  useEffect(() => {
    const fireEmailRecord = async () => {
      try {
        const response = await financialService.emailRecord(state.phoneNumber);
        actions.updateFormData('isQualified', response?.isQualified ?? false);
      } catch (err) {
        console.error('emailRecord failed:', err);
        actions.updateFormData('isQualified', false);
      } finally {
        setIsLoading(false);
      }
    };

    fireEmailRecord();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const scheduleCallClick = async () => {
    initCalendly();
    try {
      await financialService.requestCallback({
        phoneNumber:      state.phoneNumber,
        lastName:         state.clientName,
        emailId:          state.email,
        requestCallback:  true,
        scheduleMeeting:  true,
      });
    } catch (err) {
      console.error('requestCallback failed:', err);
    }
  };

  const handleSubmit = async () => {
    if (userChecked) {
      actions.updateFormData('requestCallback', true);
      setShowDefaultThankYou(true);
      try {
        await financialService.requestCallback({
          phoneNumber:     state.phoneNumber,
          lastName:        state.clientName,
          emailId:         state.email,
          requestCallback: true,
          scheduleMeeting: false,
        });
      } catch (err) {
        console.error('requestCallback failed:', err);
      }
    } else {
      setShowFinalMinimal(true);
    }
  };

  // ── Spinner while emailRecord is in flight ───────────────────────────────
  if (isLoading) {
    return (
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6 }}>
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="body1" color="text.secondary">
            Almost there…
          </Typography>
        </Box>
      </CardContent>
    );
  }

  // ── Main render ───────────────────────────────────────────────────────────
  return (
    <CardContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', my: -2 }}>
        <Zoom in={true}>
          <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
        </Zoom>

        {showDefaultThankYou ? (
          <>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              Thank You, {state.clientName.split(' ')[0]}!
            </Typography>
            <Typography variant="h6" sx={{ mb: 2 }}>
              We now have everything needed to determine your personalized asset allocation aligned with your goals and risk tolerance.
            </Typography>
            <Typography variant="h6" sx={{ mb: 2 }}>
              We will be in touch shortly to present this to you.
            </Typography>
            <Typography variant="h6" sx={{ mb: 2 }}>
              We thank you for planning your goals with Marcellus.
            </Typography>
          </>
        ) : showFinalMinimal ? (
          <Typography variant="h6" sx={{ mb: 2 }}>
            Your goals are planned. Your asset allocation report has been emailed. Thank You!
          </Typography>
        ) : state.isQualified ? (
          <>
            <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
              Your goals are planned. Now book a call with our Investment Counsellor to review your Asset Allocation.
            </Typography>

            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={scheduleCallClick}
              sx={{ py: 1.5, px: 4, borderRadius: 2, fontWeight: 'bold', mb: 2 }}
            >
              Schedule a Meeting
            </Button>

            <FormControlLabel
              control={
                <Checkbox
                  checked={userChecked}
                  onChange={(e) => setUserChecked(e.target.checked)}
                />
              }
              label="Can't find a slot? Request a callback instead."
              sx={{ mb: 3 }}
            />

            <Button
              variant="contained"
              color="success"
              size="large"
              onClick={handleSubmit}
              sx={{ py: 1.5, px: 4, borderRadius: 2, fontWeight: 'bold' }}
            >
              SUBMIT
            </Button>
          </>
        ) : (
          <Typography variant="h6" sx={{ mb: 2 }}>
            Your goals are planned. Your asset allocation report has been emailed. Thank You!
          </Typography>
        )}
      </Box>
    </CardContent>
  );
};

export default LastPage;